export default __webpack_public_path__ + "images/52b6c3a65320aabb6349328d74de3fc6-tank1.png";